import styled from "@emotion/styled"
import colors from "theme/colors"
import { Container, NewText } from "ui"
import { extractProperty } from "utils"
import ShareHolderSwiper from "./ShareHolderSwiper"

const StyledPageDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 0px;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 0px;
  }
`

const StyledInnerWrapper = styled.div`
  padding-top: 32px;
  display: flex;
  justify-content: flex-start;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
    justify-content: center;
  }
`

type Props = {
  data: any
  stockHolderData: any
  asOf: string
  dateText: string
  children: React.ReactNode
}

function ShareholdersMain({ data, stockHolderData, dateText, children }: Props) {
  const mainTitle = extractProperty(data, "mainTitle")

  return (
    <Container>
      <StyledPageDiv>
        {children}
        <StyledInnerWrapper>
          <NewText
            component={"h1"}
            desktopFontSize={40}
            desktopLineHeight={"44px"}
            desktopFontWeight={400}
            mobileFontSize={32}
            mobileLineHeight={"36px"}
            color={colors.black}
          >
            {mainTitle}
          </NewText>
        </StyledInnerWrapper>

        <ShareHolderSwiper stockHolderData={stockHolderData} dateText={dateText} />
      </StyledPageDiv>
    </Container>
  )
}

export default ShareholdersMain
